import { DateField } from 'components/form-fields/types'
import { Address } from 'components/form-fields/address-section/types'
import { ProducerContactFormInput, ProducerContactSteps } from '../types'

// TYPES

export type GeneratorStepProps = {
  formInput: ProducerContactFormInput
  handleNext?: (input: any) => void
  handlePrevious?: (input: any) => void
  setCurrentStep?: (step: ProducerContactSteps) => void
}

export type CompanyDataInputs = {
  [CompanyDataFieldKeys.COMPANY_ACTIVITY]: string
  [CompanyDataFieldKeys.COMPANY_NAME]: string
  [CompanyDataFieldKeys.COMPANY_NUMBER]: string
  [CompanyDataFieldKeys.CONTACT_PERSON]: string
  [CompanyDataFieldKeys.EMAIL]: string
  [CompanyDataFieldKeys.MOBILE_PHONE]: string
  [CompanyDataFieldKeys.COMPANY_ADDRESS]: Address
}

export type InstallationsInputsArray = {
  installations: InstallationsInputs[]
}

export type InstallationsInputs = {
  [InstallationsFieldKeys.INSTALLATION_TYPE]: InstallationTypes
  [InstallationsFieldKeys.EXPIRATION_CURRENT_CONTRACT]?: DateField
  [InstallationsFieldKeys.INSTALLED_POWER]: number
  [InstallationsFieldKeys.PRODUCED_VOLUME]?: number
  [InstallationsFieldKeys.INJECTED_VOLUME]?: number
  [InstallationsFieldKeys.EAN_INJECTION]?: string
  [InstallationsFieldKeys.INSTALLATION_ADDRESS]: Address
}

export type CommentsInput = {
  [ExtraDataFieldKeys.QUESTIONS_COMMENTS]: string
}

// ENUMS

export enum CompanyDataFieldKeys {
  COMPANY_ACTIVITY = 'companyActivity',
  COMPANY_NAME = 'companyName',
  COMPANY_NUMBER = 'companyNumber',
  CONTACT_PERSON = 'contactPerson',
  EMAIL = 'email',
  MOBILE_PHONE = 'mobilePhone',
  COMPANY_ADDRESS = 'companyAddress'
}

export enum InstallationsFieldKeys {
  INSTALLATION_TYPE = 'installationType',
  EXPIRATION_CURRENT_CONTRACT = 'expirationCurrentContract',
  INSTALLED_POWER = 'installedPower',
  PRODUCED_VOLUME = 'producedVolume',
  INJECTED_VOLUME = 'injectedVolume',
  EAN_INJECTION = 'eanInjection',
  INSTALLATION_ADDRESS = 'installationAddress'
}

export enum InstallationTypes {
  EXISTING = 'existing',
  NEW = 'new'
}

export enum ExtraDataFieldKeys {
  QUESTIONS_COMMENTS = 'questionsComments'
}
